var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.display),expression:"display"}],attrs:{"to":_vm.path,"text":"","block":""}},[_vm._v(" "+_vm._s(_vm.displayName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }